import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ArrowRightIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M12.6171 7.44186C12.8921 7.44186 13.1151 7.66399 13.1151 7.93799C13.1151 8.21199 12.8921 8.43411 12.6171 8.43411H3.32037C3.0453 8.43411 2.82231 8.21199 2.82231 7.93799C2.82231 7.66399 3.0453 7.44186 3.32037 7.44186H12.6171Z"
      fill="currentColor"
    />
    <path
      d="M7.61673 2.95672C7.81123 2.76297 8.12651 2.76297 8.32101 2.95672L12.9698 7.58753C13.164 7.78131 13.1642 8.09544 12.9698 8.28909L8.32101 12.9189C8.12651 13.1127 7.81123 13.1127 7.61673 12.9189C7.42239 12.7252 7.42228 12.4111 7.61673 12.2174L11.9125 7.93734L7.61673 3.65827C7.42223 3.46452 7.42223 3.15047 7.61673 2.95672Z"
      fill="currentColor"
    />
  </svg>
);
